import { Container, Row, Col } from 'react-bootstrap'
import { Image } from 'react-bootstrap'
import Website from '@group-devs/yfp7-global-modules/utils/request/WebsiteRequest'
import { getUrl } from '@group-devs/yfp7-global-modules/utils/general'
import {useEffect,useState} from 'react'

const website = new Website(process.env.apiDomain)

const AboutMe = ({ global, avatar }) => {
    const id= "AboutMe"
    // FIX: Changed props.global to global since props are destructured
    const { data: pageContent, isLoading } = website.swrPageContent(getUrl(global.host, global.path))
    const [about, setAbout] = useState({photo: null, about: null})
    
    // Use default image when avatar is null/empty
    const defaultPhoto = avatar || '/images/7bs/profile-default.jpg';
    
    const DefaultAbout = () => (
        <p className="ml-3">Thanks for visiting my site!
            <br /><br />
            Have you ever been in that awkward situation when you came across someone<br />whose name you simply can't recall?
            <br /><br />
            Or perhaps, forgot something you know you should be able to remember?
            <br /><br />
            When I started noticing that I was forgetting things far too often, and words and names<br />
            of people I knew I should know were just not coming to me like before,<br />
            I started looking into ways to improve my memory.
            <br /><br />
            And I was surprised to learn that the brain's neural<br />
            connections actually start declining as early as age 20.<br />
            And by age 45, this decline tends to occur even faster.
            <br /><br />
            This was something that really worried me.
            <br /><br />
            You see, I know how much a great mind improves our lives, from work to family life.<br />
            I wanted to keep my memory and have a sharp mind for as long as possible.
            <br /><br />
            I also discovered that brain health is something that is not given much attention medically<br />
            until there's a dramatic decline or a disease.
            <br /><br />
            If you're like me, I'd much rather prevent brain health issues instead of trying to fix it after the damage has<br />been done.
            <br /><br />
            <strong>Let's face it, our brains affect pretty much everything we do and who we are as a person.</strong><br />
            This is why I feel so strongly about sharing this eBook with you.
            <br /><br />
            As it turns out, there are several powerful and natural ways you can reduce the rate at which your brain<br />degenerates.
            And I want to tell as many people about them as possible.
            <br /><br />
            The earlier you learn about them, the bigger the difference you can make,<br />
            and the happier life can be for you and your family!
            <br /><br />
            I hope the information in this insightful report will help you as much as it's helped me.
            <br /><br />
            Here's to a healthy and happy brain!
            <br />
        </p>
    )
    
    useEffect(()=>{
        if (pageContent)
        {
            let content = JSON.parse(pageContent.content)
            if (content && content[id])
                setAbout({...content[id]})
        }
    },[pageContent])

return (
    <>
    <div className="sevenWays__AboutMe py-5">
        <Container className="py-5">
            <Row>
                <Col lg={3} md={3} sm={12} className="justify-content-center">
                { !isLoading ? 
                    <img className="sevenWays__Client--img img-fluid m-auto w-100" src={about.photo ? about.photo : defaultPhoto} alt="Client" />
                : null }
                </Col>
                <Col lg={9} md={9} sm={12}>
                <h3 className="ml-3 mt-2">ABOUT ME</h3>
                { !isLoading ?
                    about.about ? <div dangerouslySetInnerHTML={{ __html: about.about }} />
                    : <DefaultAbout/>
                : null }
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx>{`
        .sevenWays__AboutMe{
        background: #FFF;
        }
        h3{
            color: #47d9bf;
            font-weight: 500px;
        }
        `}
    </style>
    </>
);
}
export default AboutMe;